export class EventEmitter<EventMap extends Record<string, any>> {
  #emitter = new EventTarget();

  dispatch<E extends Extract<keyof EventMap, string>>(
    type: E,
    ...args: EventMap[E] extends void ? [] : [event: EventMap[E]]
  ): void {
    const event = new CustomEvent(type, {
      detail: args[0] as EventMap[E],
    });

    this.#emitter.dispatchEvent(event);
  }

  on<E extends Extract<keyof EventMap, string>>(
    type: E,
    cb: (event: CustomEvent<EventMap[E]>) => void,
    { once, signal }: { once?: boolean; signal?: AbortSignal } = {},
  ) {
    this.#emitter.addEventListener(type, cb as EventListener, { once, signal });

    return () => {
      this.#emitter.removeEventListener(type, cb as EventListener);
    };
  }

  // helper a la https://nodejs.org/api/events.html#eventsonceemitter-name-options
  static once<MAP extends Record<string, any>, E extends Extract<keyof MAP, string>>(
    emitter: EventEmitter<MAP>,
    type: E,
    { signal }: { signal?: AbortSignal } = {},
  ) {
    return new Promise<MAP[E]>((resolve) => {
      emitter.on(
        type,
        (event) => {
          resolve(event.detail);
        },
        { once: true, signal },
      );
    });
  }
}
